Flup.service("modal", function(flup){
   var that = this;
   var _allModals = {};
   
   that.current = null;
   that.closeCurrent = function(){
      that.current && that.current.close();
   }

   that.resizeCurrent = function(){
      that.current && that.current.resize();
   }

   that.get = function(name){
		return _allModals[name];
   }
   that.getClosest = function($elm){
      var $closest = $elm.closest(".modal[data-modal]");
      if($closest.length) return that.get($closest.data("modal"));
      return null;
   }

   that.create = function(name){
      return new Modal(name);
   }

   var Modal = function(_name){
      var it = this,
         _selector = ".modal[data-modal='"+_name+"']",
         _$elm = $(_selector),
         _$content = _$elm.find(".modal-content"),
         _isFullHeight = _$content.is(".full-height"),
         _defaultOpt = {
            overlayClose: false,
            onClose: null,
            onOpen: null,
            onAccept: null,
            onCancel: null,
            autoOpen: false,
         },
         _opt = $.extend({}, _defaultOpt, _$elm.data("modal-opt")||{});
      
      _allModals[_name] = it;
      it.elm = function(){ return _$elm; }
      it.getName = function(){ return _name; }
      it.resize = function(){
         if(_isFullHeight) return;
         var top = ($(window).outerHeight() - _$content.outerHeight())/2,
            marginBottom = 0;

         if(top < 30) top = marginBottom = 30;
         _$content.css({"top": top, "margin-bottom": marginBottom});
      }

      it.open = function(){
         if(that.current){
            if(that.current.getId() == _id){
               return;
            }else{
               that.current.close();
            }
         }
         that.current = this;
   
         _$elm.fadeIn('fast');
         it.resize();
         //bodyScrollLock.disableBodyScroll(this.$modal[0]);
         $("html,body").addClass("modal-opened");
         _$elm[0].scrollTop = 0;
         _opt.onOpen && _opt.onOpen(it);
      }

      it.close = function(){
         that.current = null;
         _$elm.fadeOut('fast');
         _opt.onClose && _opt.onClose(it);
         $("html,body").removeClass("modal-opened");
         //bodyScrollLock.enableBodyScroll(this.$modal[0]);
      }

      it.accept = function(){
         it.close();
         _opt.onAccept && _opt.onAccept(it);
      }
   
      it.cancel = function(){
         it.close();
         _opt.onCancel && _opt.onCancel(it);
      }

      it.setOptions = function(opt){
         _opt = $.extend({}, _opt, opt);
      }
      //INITIALIZE ------------------------------------
      $(window).resize(function(){ it.resize(); });
      
      _$elm.click(function(e){
         if( !_opt.overlayClose || $(e.target).is(_selector+" *") ) return;
         it.close();
      });

      if(_opt.autoOpen) it.open();
   }
});

Flup.link("modal", function(flup, $elm, value){
   $elm.attr("data-modal", value);
   flup("modal").create(value);
});

Flup.click("modal-open", function(flup, $elm, value, e){
   var modal = value ? flup("modal").get(value) : flup("modal").getClosest($elm);
   modal && modal.open();
});

Flup.click("modal-close", function(flup, $elm, value, e){
   var modal = value ? flup("modal").get(value) : flup("modal").getClosest($elm);
   modal && modal.close();
});

/*Flup.click("modal-accept", function(flup, $elm, value, e){
   var modal = value ? flup("modal").get(value) : flup("modal").getClosest($elm);
   modal && modal.accept();
});

Flup.click("modal-cancel", function(flup, $elm, value, e){
   var modal = value ? flup("modal").get(value) : flup("modal").getClosest($elm);
   modal && modal.cancel();
});*/